import styled from 'styled-components';

const StyledQueryRow = styled.div`
  background-color: ${(props) =>
    !props.isDragging
      ? props.theme.colors.secondary_alpha_3
      : props.theme.colors.secondary_alpha_1};
  border-left: ${(props) =>
    !props.isDragging ? '0' : `3px solid ${props.theme.colors.secondary}`};
  padding: ${(props) => props.theme.spacing.small}
    ${(props) => props.theme.spacing.medium};
  border-radius: 4px;
  display: flex;
`;

export default StyledQueryRow;
